// @codekit-prepend 'bower_components/bootstrap/dist/js/bootstrap.bundle.js';
// @codekit-prepend 'bower_components/cssua.js/cssua.js';
// @codekit-prepend 'bower_components/slick-carousel/slick/slick.js';
// @codekit-prepend '../bower_components/fullpage.js/src/fullpage.js';
// @codekit-prepend '../bower_components/fullpage.js/dist/fullpage.extensions.min.js';
// @codekit-prepend 'fullpage.fadingEffect.min.js';
// @codekit-prepend 'pivot-base.js';

jQuery( document ).ready( function( $ ) {

  // Activate fullPage
  if ( $( window ).width() > 767 ) {
    $( '#pd-content' ).fullpage({
      fadingEffect: true,
      fadingEffectKey: 'QU5ZXzB2U1ptRmthVzVuUldabVpXTjBTUVc=',
      licenseKey: '83C8B7B7-DC894395-95D389DA-B33440BB',
      responsiveWidth: 768,
      sectionSelector: '#pd-content > .wp-block-group',
      verticalCentered: false,
      onLeave: function( origin, destination, direction ) {

        // Fade in "How It Works" steps
        if ( $( destination.item ).hasClass( 'pd-group-how-it-works' ) ) {
          $( '.pd-steps > div' ).each( function( index, el ) {
            setTimeout( function() {
              $( el ).css( 'opacity', 1 );
            }, ( index + 1 ) * 500 );
          });
        }
      }
  	});

    $( '#pd-more' ).on( 'click', function() {
      fullpage_api.moveSectionDown();
    });
  }

  // Itinerary Slick slider
  var itinerarySlick = $( '#pd-itinerary-slick' ).slick({
    arrows: false,
    responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1
      }
    }
  ],
  slidesToShow: 3,
  slidesToScroll: 1
  });
  $( '#pd-itinerary-slick-prev' ).on( 'click', function() {
    itinerarySlick.slick( 'slickPrev' );
  });
  $( '#pd-itinerary-slick-next' ).on( 'click', function() {
    itinerarySlick.slick( 'slickNext' );
  });

  // Testimonial Slick slider
  var testimonialSlick = $( '#pd-testimonial-slick' ).slick({
    arrows: false
  });
  $( '#pd-testimonial-slick-prev' ).on( 'click', function() {
    testimonialSlick.slick( 'slickPrev' );
  });
  $( '#pd-testimonial-slick-next' ).on( 'click', function() {
    testimonialSlick.slick( 'slickNext' );
  });

  // Make fields auto-expand
  $( '#gform_wrapper_1 label' ).on( 'click', function() {
    $( this ).next().find( '.form-control' ).focus();
  });

  // Show completed form fields
  function pdShowCompleted() {
    $( '#gform_wrapper_1 .form-control' ).each( function() {
      $( this ).parent().prev().removeClass( 'pd-valid' );
      if ( $( this ).val().length ) {
        $( this ).parent().prev().addClass( 'pd-valid' );
      }
    });
  }
  $( '#gform_wrapper_1 *' ).on( 'blur', function() {
    pdShowCompleted();
  });
  $( '#gform_wrapper_1' ).on( 'keydown', function( e ) {
    if ( e.keyCode == 9 ) {
      pdShowCompleted();
    }
  });
  $( '#gform_wrapper_1' ).on( 'change', function( e ) {
    pdShowCompleted();
  });

  // Triggers real submit button from our custom one
  $( '#pd-form-submit' ).on( 'click', function() {
    $( '#gform_submit_button_1' ).click();
  });

  // Custom validation messages
  $( document ).on( 'gform_post_render', function() {

    // Invalid feedback found
    if ( $( '.invalid-feedback.gfield_description' ).length ) {
      $( '#pd-form-footer-text-error' ).removeClass( 'd-none' );
      $( '#pd-form-footer-text-default' ).addClass( 'd-none' );
    }
  });

});
